import { Component, OnInit, ViewChild } from '@angular/core';
import { QueryConditionPropertyEditorBase } from '../../types/property-editor.types';
import { DropDownPropertyEditorComponent } from '../drop-down-property-editor/drop-down-property-editor.component';

@Component({
  selector: 'df-show-condition-property-editor',
  templateUrl: './show-condition-property-editor.component.html',
  styleUrls: ['./show-condition-property-editor.component.css']
})
export class ShowConditionPropertyEditorComponent extends QueryConditionPropertyEditorBase implements OnInit {
  get entityAttribute(): string {
    return this._entityAttribute;
  }
  set entityAttribute(val: string) {
    this._entityAttribute = val;
    this.afterSetControlValue(null);
  }

  get checkedEntityAttributes() {
    return this._checkedEntityAttributes;
  }
  set checkedEntityAttributes(val: any[]) {
    this._checkedEntityAttributes = val;
    this.afterSetControlValue(null);
  }

  _entityAttribute: string;
  _checkedEntityAttributes: any[] = [];

  @ViewChild('dropDownEditor') dropDownEditor: DropDownPropertyEditorComponent;

  getAttributeName(code: string): string {
    const attr = this.checkedEntityAttributes.find((s) => s.name === code);
    return attr ? attr.caption : '';
  }

  addEntityAttribute() {
    if (!this.entityAttribute) {
      return;
    }
    const checkAttr = this.checkedEntityAttributes.find((s) => s.name === this.entityAttribute);
    if (checkAttr) {
      return;
    }
    const attr = this.entityAttributesSetting.items.find((s) => s.name === this.entityAttribute);
    this.checkedEntityAttributes.push(attr);
  }

  deleteAttribute(code: string) {
    this.checkedEntityAttributes = this.checkedEntityAttributes.filter((s) => s.name !== code);
  }

  afterSetControlValue(value: any) {
    if (this.checked) {
      this.valueChange.emit({
        checked: this.checked,
        serialNo: this.serialNo,
        rule: this.rule,
        checkedEntityAttributes: this.checkedEntityAttributes
      });
    } else {
      this.valueChange.emit({ checked: this.checked });
    }
  }

  afterControlValueInit() {
    if (!this.value) {
      this.value = {};
    }
    this.checked = this.value['checked'];
    this.serialNo = this.value['serialNo'] ? this.value['serialNo'] : 1;
    this.rule = this.value['rule'] ? this.value['rule'] : 'eq';
    // this.entityAttribute = this.value['entityAttribute'];
    this.checkedEntityAttributes = this.value['checkedEntityAttributes'] || [];
    if (this.checkedEntityAttributes.length === 0) {
      this.setSingleAttribute();
    }
  }

  afterEntityAttributeChange() {
    this.checkedEntityAttributes.forEach((c, index) => {
      const checked = this.entityAttributesSetting.items.find((r) => r.name === c.name);
      if (!checked) {
        this.checkedEntityAttributes.splice(index, 1);
      }
    });
    this.setSingleAttribute();
  }

  /**
   * è®¾ç½®åå±æ§æ¶çå±ç¤ºå­æ®µ
   *
   *
   * @memberOf ShowConditionPropertyEditorComponent
   */
  setSingleAttribute() {
    if (this.entityAttributesSetting.items.length === 2) {
      const first = this.entityAttributesSetting.items[1];
      if (first) {
        this.checkedEntityAttributes = [first];
      }
    }
  }
}
